module.exports = __webpack_public_path__ + "assets/img/kv-db8db461.jpg";